/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { TabPanel as OriginalTabPanel } from '@fiverr-private/navigation';
import { useParentPropsOverrideContext } from '@fiverr-private/ui_utils';
import withImpression from '../helpers/withImpression';

const TabPanel = forwardRef(({ children, ...props }, ref) => {
    const context = useParentPropsOverrideContext();

    return (
        <div ref={ref}>
            <OriginalTabPanel {...props} {...context}>
                {children}
            </OriginalTabPanel>
        </div>
    );
});

export default withImpression(TabPanel);
